import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';

import ReactDOM from 'react-dom';
import App from './App';

// import store from './redux/store/index';
// import * as types from './redux/constants';

import * as serviceWorker from './serviceWorker';

import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));

// serviceWorker.register({
//     onSuccess: () => store.dispatch({ type: types.SERVICE_WORKER_INIT }),
//     onUpdate: (reg) => store.dispatch({ type: types.SERVICE_WORKER_UPDATE, payload: reg })
// });
serviceWorker.unregister();
